module.exports = __webpack_public_path__ + "static/media/freshways.915c0356.svg";